<template>
    <div class="profile-background" :style="backgroundStyle">
      <div class="profile-background-img" :style="imageStyle" :class="topImageClass"></div>
    </div>
</template>

<script>
export default {
  props: {
    item: {
      default () {
          return {}
      },
      type: Object
    }
  },
  data() {
    return {}
  },
    computed: {
        imageStyle() {
            return this.showTopImage ? {
                backgroundImage: 'url(' + this.$processUrl(this.topImageFilePath) + ')'
            } : null
        },
        topImageClass() {
            if (!this.showTopImage) return 'top-left'
            if (this.topImagePosition === 1) return 'top-left'
            if (this.topImagePosition === 2) return 'top-center'
            if (this.topImagePosition === 3) return 'top-right'
            if (this.topImagePosition === 4) return 'top-panorama'
            return 'top-center'
        },
        backgroundStyle() {
            return this.showTopImage ? {
                backgroundColor: this.topImageBgColor
            } : null
        },
        showTopImage() {
            return this.item
                && this.item.isActive
                && this.item.filePath
        },
        topImageUrl() {
            return this.showTopImage ? this.item.url : ''
        },
        topImageFilePath() {
            return this.showTopImage ? this.item.filePath : ''
        },
        topImageBgColor() {
            return this.showTopImage ? this.item.text : ''
        },
        topImagePosition() {
            return this.showTopImage ? this.item.type : 0
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$inside-width = 1260px
$outside-padding = 84px
$doc-container-h-padding = 140px
$doc-container-v-padding = 70px
$outside-width = $inside-width + ($outside-padding * 2)
$el-vertical-space = 10px

.profile-background
    width 100%
    responsive-styling-auto-scale(height, 340, $outside-width)
    position absolute
    top 0
    left 0
    overflow hidden
    // display none

    .profile-background-img
        position absolute
        top 0
        left 0
        width 100%
        background-position-y top

        &.top-center
            background-position-x center
            background-size contain
            background-repeat no-repeat
            responsive-styling-auto-scale(height, 236, $outside-width)

        &.top-left
            background-position-x left
            background-size contain
            background-repeat no-repeat
            responsive-styling-auto-scale(height, 236, $outside-width)

        &.top-right
            background-position-x right
            background-size contain
            background-repeat no-repeat
            responsive-styling-auto-scale(height, 236, $outside-width)

        &.top-panorama
            background-position top center
            background-size cover
            background-repeat no-repeat
            responsive-styling-auto-scale(height, 340, $outside-width)
</style>



// WEBPACK FOOTER //
// src/modules/documents/components/PublicDocumentTopBackground.vue